import * as Scrivito from "scrivito";
import { createContext, useContext, useEffect, useState } from "react";
import { getKeycloak } from "^/Components/Authentication/keycloak";
import { isBrowser } from "^/utils/isBrowser";
import { scheduleTokenRefresh } from "./tokenRefresh";

const AuthContext = createContext();

export const AuthenticationProvider = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!isBrowser) return;

    const keycloak = getKeycloak();

    keycloak
      .init({
        onLoad: "check-sso",
        pkceMethod: "S256",
        checkLoginIframe: true,
      })
      .then((auth) => {
        const prevLogin = window.localStorage.getItem("keycloakLoginPresent");

        if (auth) {
          window.localStorage.setItem("keycloakLoginPresent", "loggedIn");
          setAuthenticated(true);

          if (prevLogin === "loggedIn") {
            Scrivito.setVisitorIdToken(keycloak.idToken);
            scheduleTokenRefresh();
          } else {
            window.location.reload();
          }
        } else {
          window.localStorage.setItem("keycloakLoginPresent", "false");
          setAuthenticated(false);
          if (prevLogin === "loggedIn") {
            window.location.reload();
          }
        }
      })
      .catch((error) => {
        console.error("Keycloak initialization failed", error);
        window.localStorage.setItem("keycloakLoginPresent", "false");
        setAuthenticated(false);
      })
      .finally(() => {
        setInitialized(true);
      });
  }, []);

  return (
    <AuthContext.Provider value={{ authenticated, initialized }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
